module.exports = __webpack_public_path__ + "img/folder.ba02e2b5.png";